export const currentCompetence = (value = new Date()) => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Sao_Paulo",
    year: "numeric",
    month: "2-digit",
  }).formatToParts(value);
  const read = (type) => parts.find((part) => part.type === type)?.value;
  return `${read("year")}-${read("month")}`;
};

export const companyQuery = (companyId) => (
  companyId ? `?company_id=${encodeURIComponent(companyId)}` : ""
);

export const shiftCompetence = (value, delta) => {
  const [year, month] = value.split("-").map(Number);
  const ordinal = year * 12 + month - 1 + delta;
  return `${Math.floor(ordinal / 12).toString().padStart(4, "0")}-${String((ordinal % 12) + 1).padStart(2, "0")}`;
};

export const moduleFilters = ({ from, months = 24, scenario = "base", filters = {} }) => ({
  from,
  months,
  scenario,
  legalEntityId: filters.legalEntityId ?? null,
  projectKey: filters.projectKey ?? null,
  costCenterId: filters.costCenterId ?? null,
});

export const scenarioLabel = (value) => ({
  base: "Base",
  conservative: "Conservador",
  stress: "Estresse",
}[value] || value);
